import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Configuration for Account Database (mindsprint-cfb30)
const accountConfig = {
  apiKey: "AIzaSyD8QilqDgTe1HHZOhWJBwsPkRthyQcRbYk",
  authDomain: "mindsprint-cfb30.firebaseapp.com",
  projectId: "mindsprint-cfb30",
  storageBucket: "mindsprint-cfb30.firebasestorage.app",
  messagingSenderId: "270430519422",
  appId: "1:270430519422:web:3c0a1551f8fa059732582f",
  measurementId: "G-5R4FTHC0YK"
};

// Configuration for Ledger Database (ledger-17f64)
const ledgerConfig = {
  apiKey: "AIzaSyDQXrWouwlb9-NcoSFzWNVrxysSXzzv4Cw",
  authDomain: "ledger-17f64.firebaseapp.com",
  projectId: "ledger-17f64",
  storageBucket: "ledger-17f64.firebasestorage.app",
  messagingSenderId: "667847752671",
  appId: "1:667847752671:web:afbb6ff297aa3770f1626a",
  measurementId: "G-6Q91KZ5JXZ"
};

// Helper to prevent re-initialization error during hot reload
const initApp = (name: string, config: any) => {
    const apps = getApps();
    const existing = apps.find(a => a.name === name);
    return existing || initializeApp(config, name);
};

// Initialize apps with explicit names
const accountApp = initApp('account', accountConfig);
const ledgerApp = initApp('ledger', ledgerConfig);

// Initialize Analytics for Ledger (as per request snippet)
let ledgerAnalytics;
try {
  ledgerAnalytics = getAnalytics(ledgerApp);
} catch (e) {
  console.warn("Firebase Analytics could not be initialized for Ledger", e);
}

// Initialize Firestore instances
const accountDb = getFirestore(accountApp);
const ledgerDb = getFirestore(ledgerApp);

export { accountDb, ledgerDb };
